import axios from 'axios'
import { authContext } from '../adalConfig'

export const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000'
export const API_URL = API_HOST + '/api/'

export const getToken = () => {
  return authContext.getCachedToken(authContext.config.clientId)
}

axios.defaults.baseURL = API_URL
axios.defaults.headers.common['Authorization'] = `JWT ${getToken()}`

export const getUserInfo = () => {
  return axios.get(`user_info/`)
}

export const getDashboard = () => {
  return axios.get(`narratives/dashboard/`)
}

export const getDisclaimers = () => {
  return axios.get(`disclaimers/`)
}

export const getNarratives = (cspCountryKey, year) => {
  return axios.get(`narratives/?csp_country_key=${cspCountryKey}&year=${year}`)
}

export const getNarrative = id => {
  return axios.get(`narratives/${id}/`)
}

export const transitionNarrative = (narrative, transition) => {
  if (transition === 'initialize') {
    return axios.post(`narratives/initialize/`, {
      csp_country_key: narrative.csp_country_key,
      year: narrative.year,
    })
  }
  return axios.post(`narratives/${narrative.id}/change_state/?transition=${transition}`, {
    // for disclaimer or comment transitions other attributes will be ignored
    csp_country_key: narrative.csp_country_key,
    year: narrative.year,
    text_box1: narrative.text_box1,
    text_box2: narrative.text_box2,
    table: narrative.table,
    text_box1_comment: narrative.text_box1_comment,
    text_box2_comment: narrative.text_box2_comment,
    table_comment: narrative.table_comment,
    disclaimer: narrative.disclaimer_id,
    version: narrative.version,
  })
}
